/**
 * Warning banner shown above the Gantt chart when multiple submissions
 * have target dates within 7 days of each other.
 */

import { TriangleAlert } from 'lucide-react';
import type { ConflictCluster } from './PlanningViewPage';

const fmt = (d: Date) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export function ConflictWarning({ cluster }: { cluster: ConflictCluster }) {
  const { submissions, earliest, latest, span } = cluster;
  const dateRange = span === 0 ? fmt(earliest) : `${fmt(earliest)} – ${fmt(latest)}`;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-lg text-amber-700 text-sm">
      <TriangleAlert className="w-4 h-4 shrink-0" />
      <span>
        <strong>{submissions.length} deadlines within {span} days</strong> ({dateRange})
      </span>
    </div>
  );
}
